<template>
    <div v-if="isUserAuthenticated()">
        <v-dialog persistent scrollable :value="value" @input="$emit('input', $event)" max-width="400px">
            <v-card>
            <v-card-title>
                <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text style="padding-top:0px;padding-bottom:0px;height:200px;">
                <v-form v-model="valid" ref="form" lazy-validation>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs6 sm6 md6>
                        <v-menu
                          :close-on-content-click="false"
                          v-model="menuStartDate"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          max-width="290px"
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            v-model="editedItem.StartDate"
                            label="Date de début"
                            persistent-hint
                            prepend-icon="event"
                            readonly
                          ></v-text-field>
                          <v-date-picker v-model="date" no-title @input="saveStartDate(editedItem, date)"></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs6 sm6 md6>
                      </v-flex>
                      <v-flex xs6 sm6 md6>
                        <v-menu
                          :close-on-content-click="false"
                          v-model="menuEndDate"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          max-width="290px"
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            v-model="editedItem.EndDate"
                            label="Date de fin"
                            persistent-hint
                            prepend-icon="event"
                            readonly
                          ></v-text-field>
                          <v-date-picker v-model="date" no-title @input="saveEndDate(editedItem, date)"></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs6 sm6 md6></v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="close">Annuler</v-btn>
                <v-btn color="blue darken-1" flat @click.native="generate">Générer</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import auth from '@/auth'
import moment from 'moment'
import TemplateAdminComponent from '@/components/TemplateAdmin.vue'
import APIReport from '@/api/report'
const APIService = new APIReport();

var axios = require('axios')

export default {
   props: {
    value: { type: Boolean, required: true },
  },
  components:
  {
    TemplateAdminComponent
  },

  mounted() {
    this.$refs.form.resetValidation()
  },

  data() {
    //debugger;
    return {
        loading: false,
        valid: false,
        startDate: '',
        date: null,
        menuStartDate: false,
        menuEndDate: false,
        editedItem: {},
    }
  },

  computed: {
    formTitle () {
      return 'Rapport des notes téléphoniques'
    }
  },

  created(){
    this.initialize()
    //alert("created")
  },

  methods: {
    isUserAuthenticated() {
      return auth.isUserAuthenticated()
    },

    logout() {
      auth.logout()
    },

    initialize () {
      this.editedItem.StartDate = moment().subtract(1, 'days').format("YYYY-MM-DD")
      this.editedItem.EndDate = moment().format("YYYY-MM-DD")
    },

    close () {
      this.$emit('input', false)
      // setTimeout(() => {
      //   this.editedItem = Object.assign({}, this.defaultItem)
      // }, 300)
    },
    saveStartDate(item, date) {
      item.StartDate = date
      this.menuStartDate = false
    },
    saveEndDate(item, date) {
      item.EndDate = date
      this.menuEndDate = false
    },
    async generate () {
      await APIService.generatePhoneNotesExcel(this.editedItem.StartDate, this.editedItem.EndDate).then(response =>  {
          this.$emit('input', false)
        }
      )
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ModalReportPhoneNotes.vue